namespace $.$$ {
	export class $shm_hitalama_components_preview_description extends $.$shm_hitalama_components_preview_description {

		@ $mol_mem
		session( next?: { definition: $shm_hitalama_map_widget_entity_custom, text: string } | null ) {
			return next ?? null
		}

		editing() { return this.session()?.definition === this.definition() }
		text() { return this.definition().Description()?.val() ?? '' }

		draft( next?: string ) {
			const session = this.session()
			if( !session || !this.editing() ) return ''
			if( next !== undefined ) this.session({ ...session, text: next })
			return next ?? session.text
		}

		actions() {
			if( !this.definition().can_change() ) return []
			return this.editing() ? [ this.Cancel() ] : super.actions()
		}

		content() { return this.editing() ? [ this.Textarea(), this.Save() ] : super.content() }

		@ $mol_action
		edit( event?: Event | null ) {
			if( !event || !this.definition().can_change() ) return null
			this.session({ definition: this.definition(), text: this.text() })
			this.Textarea().focused( true )
			return null
		}

		@ $mol_action
		cancel( event?: Event | null ) {
			if( event ) this.session( null )
			return null
		}

		@ $mol_action
		save( event?: Event | null ) {
			if( !event || !this.editing() || !this.definition().can_change() ) return null
			this.definition().Description( null )!.val( this.draft() )
			this.session( null )
			return null
		}
	}
}
